import styled from 'styled-components';
import { StyledRowContent } from '../ProjectProgression.style';

export const StyledProgressionOverTime = styled.div`
  height: 100%;
`;

export const StyledGraphWrapper = styled(StyledRowContent)`
  display: flex;
  height: 90%;
  & > aside {
    width: 2%;
    height: 100%;
  }
  & > main {
    width: 98%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
